import type { NavRailDef, RailId } from './types';

export const RAIL_ORDER: RailId[] = [
  'overview',
  'patients',
  'appointments',
  'leads',
  'marketing',
  'messaging',
  'internalChat',
  'finance',
  'warehouse',
  'work',
  'hr',
  'reports',
  'catalog',
  'settings',
];

/** Org-user landing after login / root redirect. */
export const ORG_HOME_PATH = '/dashboard';

export const NAV_RAILS: NavRailDef[] = [
  { id: 'overview', labelKey: 'railOverview', defaultPath: '/dashboard' },
  { id: 'patients', labelKey: 'railPatients', defaultPath: '/patients' },
  { id: 'appointments', labelKey: 'railAppointments', defaultPath: '/appointments?view=calendar' },
  { id: 'leads', labelKey: 'railLeads', defaultPath: '/leads' },
  { id: 'marketing', labelKey: 'railMarketing', defaultPath: '/marketing/referrers' },
  { id: 'messaging', labelKey: 'railMessaging', defaultPath: '/messaging' },
  { id: 'internalChat', labelKey: 'railInternalChat', defaultPath: '/internal-chat' },
  { id: 'finance', labelKey: 'railFinance', defaultPath: '/incomes' },
  { id: 'warehouse', labelKey: 'railWarehouse', defaultPath: '/inventory/stock-in' },
  { id: 'work', labelKey: 'railWork', defaultPath: '/tasks?view=list&mine=0' },
  { id: 'hr', labelKey: 'railHr', defaultPath: '/staff' },
  { id: 'reports', labelKey: 'railReports', defaultPath: '/reports/revenue' },
  { id: 'catalog', labelKey: 'railCatalog', defaultPath: '/treatment-catalog' },
  { id: 'settings', labelKey: 'railSettings', defaultPath: '/settings' },
];
